import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons'

const BaseModal = ({modalId, modalTitle, modalTitleIcon, children}) => {
    return (
        <>
            <div className="modal fada" id={modalId} role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-purple ">
                            <p className="small lh-sm">             
                            <strong className="text-white h5">{modalTitle} <FontAwesomeIcon icon={modalTitleIcon} /></strong>   
                            </p>
                            <FontAwesomeIcon icon={faTimesCircle} className="h4" style={{ cursor: 'pointer'}} data-dismiss="modal" />
                        </div>
                        <div className="modal-body bg-white text-dark">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BaseModal
